import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { stringifyIfPresent } from 'src/lib/common';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation TrackEventNoAuth($name: String!, $attributes: JSON) {
    trackEventNoAuth(name: $name, attributes: $attributes) {
      id
    }
  }
`;

export const trackEventNoAuth = (name: string, attributes: object) => {
  const variables = {
    name,
    attributes: stringifyIfPresent(attributes),
  };

  return executeGqlMutation({
    mutation: MUTATION,
    variables,
  }).then(({ data }) => getSingleProp(data));
};
